import React, { useState } from "react";
import GeneralConfig from "./General/GeneralConfig";
import ProductConfig from "./Product/ProductConfig";

type ConfigMenuType = "general" | "product" ;

const ConfigurationTab: React.FC = () => {
  const [activeMenu, setActiveMenu] = useState<ConfigMenuType>("general");

  return (
    <div className="font-body tracking-wider">

      <div className="border-b mb-6 flex gap-8">
        {(["general", "product"] as ConfigMenuType[]).map((menu) => {
          const isActive = activeMenu === menu;

          return (
            <button
              key={menu}
              onClick={() => setActiveMenu(menu)}
              className={`pb-3 text-sm font-medium transition-colors ${
                isActive
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              {menu.charAt(0).toUpperCase() + menu.slice(1)}
            </button>
          );
        })}
      </div>

      <div className="pt-2">
        {activeMenu === "general" && <GeneralConfig />}
        {activeMenu === "product" && <ProductConfig />}
        {/* {activeMenu === "shipment" && <ShipmentConfig />} */}
      </div>

    </div>
  );
};

export default ConfigurationTab;
